import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SGWTConnectInterceptor } from './SGWTConnect.interceptor';
import { SGWTConnect } from './SGWTConnect.service';
import { SGWTConnectRequestPredicate } from './SGWTConnectRequestPredicate';
import * as i0 from "@angular/core";
var SGWTConnectModule = /** @class */ (function () {
    function SGWTConnectModule() {
    }
    SGWTConnectModule.forRoot = function (sgwtConnectFactory, predicate) {
        return {
            ngModule: SGWTConnectModule,
            providers: [
                { provide: SGWTConnect, useFactory: sgwtConnectFactory },
                { provide: SGWTConnectRequestPredicate, useValue: predicate },
                { provide: HTTP_INTERCEPTORS, useClass: SGWTConnectInterceptor, multi: true }
            ]
        };
    };
    SGWTConnectModule.ɵfac = function SGWTConnectModule_Factory(t) { return new (t || SGWTConnectModule)(); };
    SGWTConnectModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SGWTConnectModule });
    SGWTConnectModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
    return SGWTConnectModule;
}());
export { SGWTConnectModule };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SGWTConnectModule, [{
        type: NgModule
    }], null, null); })();
